export default function config($httpProvider, $compileProvider, cfpLoadingBarProvider) {
  'ngInject'
  $compileProvider.debugInfoEnabled(false)
  $httpProvider.interceptors.push('AuthorizationInterceptor')
  cfpLoadingBarProvider.includeSpinner = true
}
